import { useState, useEffect } from "react";

interface UseIsMobile {
  isMobile: boolean;
}

export const useIsMobile: () => UseIsMobile = () => {
  const [isMobile, setIsMobile] = useState<boolean>(true);
  const handleResize = () => {
    setIsMobile(window.innerWidth < 768);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return {
    isMobile,
  };
};
